export default __webpack_public_path__ + "static/media/icon-trazer-dinheiro.d3f55b0f.svg";